import React from 'react'
import Box from "@mui/material/Box"
import {Link} from "react-router-dom"
import Img from "../../../html/Img"
import Grid from "@mui/material/Grid"
import FavoriteButton from "../../../global/FavoriteButton"
import PropTypes from "prop-types"

function VideoGridItem(props) {

    const {video, index, itemKey, favoritesData, singleItem, showInstructor = true} = props

    const key = itemKey ? itemKey : `video-${index}`

    const isLiveVideo = data => {
        return data.videoCategory.find(item => (item.node && item.node.name === 'Live'))
    }

    const VideoItem = () => (
        <Box key={`videoitem=${key}`}>
            <Box mb={1}>
                {video.largeImage ?
                    <Link to={`/videos/${video.id}`}>
                        <Img src={video.largeImage.rendition.url} alt={video.title}/>
                    </Link>
                    :
                    <span><Link to={`/videos/${video.id}`}>{video.title}</Link></span>
                }
            </Box>
            <Box sx={{display: 'flex'}} mb={2}>
                {(favoritesData && video) &&
                    <FavoriteButton nid={video.id}
                                    active={favoritesData.find(item => parseInt(item.video.id) === parseInt(video.id))}/>
                }

                <strong style={{textTransform: 'uppercase'}}
                        key={`technique-${index}`}>
                    {video.title}&nbsp;
                </strong>

            </Box>
            <Box mb={1}>
                {(video.videoInstructor && showInstructor) &&
                    video.videoInstructor.map((instructor, index) => (
                        (instructor.node) &&
                        <span key={`instructor-${index}-${index}`}>
                                        <Link to={`/instructors/${instructor.node.id}`}>
                                            <strong style={{display: "inline-block"}}>{instructor.node.name}</strong>
                                        </Link>
                                    </span>

                    ))
                }
            </Box>
            <Box>
                {(video.classType !== 'TECHNIQUE' && !isLiveVideo(video)) &&
                    <Link to='/equipment'>{video.equipment}</Link>
                }
            </Box>
            <Box mb={3}>
                {(video.techniqueCategory && video.classType !== 'TECHNIQUE' && !isLiveVideo(video)) &&
                    video.techniqueCategory.map((technique, index, arr) => (
                        (technique.node) &&
                        <span key={`instructor-${index}-${index}`}>
                                        <Link to={{
                                            pathname: '/search',
                                            search: `?techniques=${technique.node.id}`
                                        }}>
                                            <strong style={{display: "inline-block"}}>{technique.node.name}</strong>
                                        </Link>{((index + 1) !== arr.length) && <span>, &nbsp;</span>}
                                    </span>
                    ))
                }
            </Box>
        </Box>

    )

    if (singleItem) {
        return (
            <VideoItem key={key}/>
        )
    } else {
        return (
            <Grid key={key} item xs={12} sm={6} md={6} xl={3}>
                <VideoItem/>
            </Grid>
        )
    }


}

VideoGridItem.protoTypes = {
    video: PropTypes.object.isRequired,
    index: PropTypes.number,
    itemKey: PropTypes.string,
    favoritesData: PropTypes.object
}

export default VideoGridItem